export default __webpack_public_path__ + "static/media/warning_icon_mini.b4375809.svg";